export const TimingValidations = {
  guests: {
    presence: true,
  },

  date: {
    presence: true,
  },

  time: {
    presence: true,
  },
};
